"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./toggle-button.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Pass in a numeric id for onToggleChange to work
 */
var ToggleButton =
/*#__PURE__*/
function (_Component) {
  _inherits(ToggleButton, _Component);

  function ToggleButton(props) {
    var _this;

    _classCallCheck(this, ToggleButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToggleButton).call(this, props));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ToggleButton, [{
    key: "onChange",
    value: function onChange() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          id = _this$props.id,
          onToggleChange = _this$props.onToggleChange; // After you select a button it needs to de-focus so it doesn't have the blue focus border.

      this.button.blur();
      if (!disabled && id) onToggleChange(id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var style = {};
      var _this$props2 = this.props,
          image = _this$props2.image,
          size = _this$props2.size,
          color = _this$props2.color,
          showText = _this$props2.showText,
          active = _this$props2.active,
          disabled = _this$props2.disabled,
          title = _this$props2.title,
          name = _this$props2.name;
      if (image) style.backgroundImage = "url(".concat(image, ")");
      if (color) style.backgroundColor = "".concat(color);
      var classname = (0, _classnames["default"])('ToggleButton', size, {
        hasImage: image,
        noText: !showText,
        active: active,
        disabled: disabled
      });
      return _react["default"].createElement("button", {
        type: "button",
        className: classname,
        ref: function ref(el) {
          _this2.button = el;
        },
        onClick: this.onChange,
        title: title
      }, _react["default"].createElement("div", {
        className: "content",
        style: style
      }, showText ? name : null));
    }
  }]);

  return ToggleButton;
}(_react.Component);

ToggleButton.propTypes = {
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].number,
  onToggleChange: _propTypes["default"].func.isRequired,
  image: _propTypes["default"].string,
  color: _propTypes["default"].string,
  size: _propTypes["default"].string,
  showText: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string
};
ToggleButton.defaultProps = {
  id: null,
  image: null,
  color: null,
  title: null,
  showText: true,
  active: false,
  disabled: false,
  size: 'medium'
};
var _default = ToggleButton;
exports["default"] = _default;